import icono1 from '/src/assets/images/ventajas/icono-1.svg';
import icono2 from '/src/assets/images/ventajas/icono-2.svg';
import icono3 from '/src/assets/images/ventajas/icono-3.svg';
import icono4 from '/src/assets/images/ventajas/icono-4.svg';
import middleImage from '/src/assets/images/ventajas/middle-image.png';

export const ventajas = {
    title: "Las ventajas </br> de tener Toke",
    subtitle: "Regístrate hoy y obtén acceso exclusivo",
    image: middleImage,

    list: [
        {
            image: icono1,
            title: "Olvídate del efectivo",
            subtitle: "<p>¿Saliste sin un peso?</br> Paga con Toke</p>",
            align: "left"
        },
        {
            image: icono2,
            title: "Resuelve rápido",
            subtitle: "<p>Para pagar solo necesitas, el QR o el número celular</p>",
            align: "left"
        },
        {
            image: icono3,
            title: "No gastes tu data",
            subtitle: "<p>El internet va por la casa cuando usas la app</p>",
            align: "right"
        },
        {
            image: icono4,
            title: "¡Es gratis!",
            subtitle: "<p>Abre tu cuenta sin cargos en segundos</p>",
            align: "right"
        }
    ]
};
